export const blockIconsActivitiesSurfingNew = (
	<span className='material-symbols-outlined'>surfing</span>
);
